import React from 'react';

/**
 * BubbleActionMenu — the Edit / Delete / Select pill row that appears
 * below a sent message when its action sheet is open.
 *
 * Shows Edit + Delete only when selectedCount < 2 (single or no selection).
 * Always shows Select so the user can start multi-select.
 */
const BubbleActionMenu = ({ onEdit, onDelete, onSelect, selectedCount = 0 }) => (
  <div className="flex gap-1 mt-1 mr-2 animate-chatFadeIn">
    {selectedCount < 2 && (
      <>
        <button
          onClick={onEdit}
          className="flex items-center gap-1 px-2.5 py-1 bg-white border border-gray-200 rounded-full text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 active:scale-95 transition-all"
        >
          <svg className="w-3.5 h-3.5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          Edit
        </button>
        <button
          onClick={onDelete}
          className="flex items-center gap-1 px-2.5 py-1 bg-white border border-gray-200 rounded-full text-xs font-medium text-red-600 shadow-sm hover:bg-red-50 active:scale-95 transition-all"
        >
          <svg className="w-3.5 h-3.5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          Delete
        </button>
      </>
    )}
    <button
      onClick={onSelect}
      className="flex items-center gap-1 px-2.5 py-1 bg-white border border-gray-200 rounded-full text-xs font-medium text-blue-600 shadow-sm hover:bg-blue-50 active:scale-95 transition-all"
    >
      <svg className="w-3.5 h-3.5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      Select
    </button>
  </div>
);

export default BubbleActionMenu;
